import { SessionDto } from "g1-commons/lib/doxecureClientTypes";
import { SignatureStatus } from "g1-commons/lib/doxecureModelTypes";
import { SectionCategory, SessionActorType } from "g1-commons/lib/doxecureTypes";

import { Dashboard, SessionFilter } from "@containers/generics/Dashboard";
import { useAuthContext } from "@hooks/useAuthContext";
import { okOrError, optlog, defaultSectionInformations } from "@utils/functions";

export const ToBeSignedDocumentsView = () => {
    const { profileId } = useAuthContext() ;
    const sessionFilter:SessionFilter = (session:SessionDto, _:SectionCategory): boolean => {
        return session.signatures?.findIndex(s => s.signatureStatus === SignatureStatus.Opened && s.signer.apid === profileId) === -1 || // Do not show here, sessions to sign (already present in 'Parapheur')
               session.creator === profileId || session.expeditor.apid === profileId;
    }
    optlog(`+++ ToBeSignedDocumentsView initialized with profile ID '${profileId}'`) ;
    
    return okOrError(
        profileId,
        (<Dashboard 
            title="Documents en attente de signature"
            emptyMessage="Pas de documents en attente de signature"
            category="to-be-signed"
            roles={[SessionActorType.Creator, SessionActorType.Expeditor, SessionActorType.Approver, SessionActorType.Signer]} 
            sectionInfos={defaultSectionInformations} 
            sessionFilter={sessionFilter}
        />),
        false,
        "Impossible d'afficher la liste des documents en attente de signature car l'identifiant de profil de la personne connectée n'a pas pu être récupéré.",
        "Connexion invalide"
    ) ;
};
